module.exports = __webpack_public_path__ + "static/media/PowerPointIcon.a8658df8.png";